import React, { useState } from "react";
import Switch from "@mui/material/Switch";
import theme from "../../../theme/Theme";
import { UpdateWorker } from "../../../queries/Workers";
import { UpdateQarule } from "../../../queries/QAruleData";
import { UpdateProfile } from "../../../queries/profileData";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
  Button,
} from "@mui/material";
import { Close } from "@mui/icons-material";

export const MySwitch = (params) => {
  const [checked, setChecked] = useState(
    params?.data?.availability === "AVAILABLE" ||
      params?.data?.availability === true
  );
  const [showWarningDialog, setShowWarningDialog] = useState(false);
  const [showTransferDialog, setShowTransferDialog] = useState(false);

  const isLastAvailableRecord =
    params?.availableRecordsCount === 1 &&
    checked &&
    params?.data?.type === "LOCAL_COLLECTION";

  const hasRemainingCases =
    params?.data?.type === "LOCAL_COLLECTION" &&
    params?.data?.remaining_cases > 0;

  const handleChange = (event) => {
    if (isLastAvailableRecord) {
      setShowWarningDialog(true);
      return;
    }

    const isChecked = event.target.checked;

    // Check if deactivating a queue with remaining cases
    if (!isChecked && hasRemainingCases) {
      setShowTransferDialog(true);
      return;
    }

    performAvailabilityUpdate(isChecked);
  };

  const performAvailabilityUpdate = (
    isChecked,
    forceDisableWithActiveCases = false
  ) => {
    const dataType = params?.data?.type;

    // Configuration for different collection types
    const mutationConfig = {
      QARULE_COLLECTION: {
        mutation: UpdateQarule,
        idField: "id",
        idValue: params?.data?.collection_id,
        payloadKey: "qarule",
      },
      LOCAL_COLLECTION: {
        mutation: UpdateProfile,
        idField: "updateProfileId",
        idValue: params?.data?.collection_id,
        payloadKey: "profile",
      },
      DEFAULT: {
        mutation: UpdateWorker,
        idField: "id",
        idValue: params?.data?.workerId,
        payloadKey: "worker",
      },
    };

    const config = mutationConfig[dataType] || mutationConfig.DEFAULT;

    const variables = {
      [config.idField]: config.idValue,
      [config.payloadKey]: {
        availability: isChecked ? "AVAILABLE" : "UNAVAILABLE",
      },
    };
    if (forceDisableWithActiveCases) {
      variables["forceDisableWithActiveCases"] = true;
    }

    params?.client
      .mutate({
        mutation: config.mutation,
        variables,
      })
      .then((response: any) => {
        setChecked(isChecked);
        if (params?.data?.type === "LOCAL_COLLECTION") {
          params.setAvailableRecordsCount(
            isChecked
              ? params?.availableRecordsCount + 1
              : params?.availableRecordsCount - 1
          );
          setShowTransferDialog(false);
        }
      })
      .catch((err) => {
        console.error(`Failed to update ${dataType}:`, err);
        setChecked(!isChecked);
      });
  };

  const handleTransfer = async (isChecked) => {
    performAvailabilityUpdate(isChecked, true);
  };

  return (
    <>
      <Switch
        checked={checked}
        onChange={handleChange}
        aria-label="Availability toggle"
        sx={{
          "& .MuiSwitch-switchBase": {
            marginTop: "4px",
            marginLeft: checked ? "-1px" : "4px",
          },
          "& .MuiSwitch-thumb": {
            boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.25)",
            height: "16px",
            width: "16px",
          },
          "& .MuiSwitch-track": {
            borderRadius: "10px",
            height: "18px",
            opacity: "1 !important",
            backgroundColor: checked
              ? theme.palette.artisticPrimary100.main
              : theme.palette.artisticStroke200.main,
          },
          "&.Mui-checked .MuiSwitch-thumb": {
            backgroundColor: "#FFFFFF",
          },
          "& .MuiSwitch-switchBase.Mui-checked": {
            color: "#FFFFFF",
            "&:hover": {
              backgroundColor: "rgba(0, 122, 255, 0.04)",
            },
          },
        }}
      />
      <Dialog
        open={showWarningDialog || showTransferDialog}
        onClose={() => {
          setShowWarningDialog(false);
          setShowTransferDialog(false);
        }}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
      >
        <DialogTitle id="dialog-title">
          {showWarningDialog
            ? "Cannot Deactivate Last Queue"
            : "Deactivate Queue"}
          <IconButton
            aria-label="close"
            onClick={() => {
              setShowWarningDialog(false);
              setShowTransferDialog(false);
            }}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="dialog-description">
            {showWarningDialog
              ? "This is the last active queue and cannot be deactivated. Please create a new queue or activate another existing queue before deactivating this one."
              : `${params?.data?.remaining_cases} case${
                  params?.data?.remaining_cases !== 1 ? "s" : ""
                } will be automatically redistributed to other available queues based on the configured criteria.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ padding: "16px  24px" }}>
          {showWarningDialog ? (
            <Button
              onClick={() => setShowWarningDialog(false)}
              variant="contained"
              color="primary"
            >
              OK
            </Button>
          ) : (
            <>
              <Button onClick={() => setShowTransferDialog(false)}>
                Cancel
              </Button>
              <Button
                onClick={() => handleTransfer(false)}
                variant="contained"
                color="primary"
              >
                Deactivate
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};
